import { z } from 'zod';
import { idSchema } from './ids';
import { invitableRoleSchema, roleSchema } from './enums';
import { displayNameSchema, emailSchema, newPasswordSchema, oneTimeTokenSchema } from './auth';

export const memberSchema = z.object({
  userId: idSchema,
  email: z.string(),
  displayName: z.string(),
  role: roleSchema,
  joinedAt: z.string(),
});
export type Member = z.infer<typeof memberSchema>;

export const changeRoleSchema = z.object({ role: roleSchema });

export const createInvitationSchema = z.object({ email: emailSchema, role: invitableRoleSchema });
export type CreateInvitationInput = z.infer<typeof createInvitationSchema>;

export const invitationSchema = z.object({
  id: idSchema,
  email: z.string(),
  role: roleSchema,
  createdAt: z.string(),
  expiresAt: z.string(),
});
export type Invitation = z.infer<typeof invitationSchema>;

/** What the invitee sees when opening the invitation link (token holder only). */
export const invitationPreviewSchema = z.object({
  workspaceName: z.string(),
  email: z.string(),
  role: roleSchema,
  accountExists: z.boolean(),
});
export type InvitationPreview = z.infer<typeof invitationPreviewSchema>;

/**
 * Accepting an invitation: an existing account accepts while signed in as the invited e-mail;
 * a new person provides a display name and password (the e-mail is verified by the link).
 */
export const acceptInvitationSchema = z.object({
  token: oneTimeTokenSchema,
  displayName: displayNameSchema.optional(),
  password: newPasswordSchema.optional(),
});
export type AcceptInvitationInput = z.infer<typeof acceptInvitationSchema>;
